import { inject, Injectable } from '@angular/core';
import { LOCALSTORAGE } from './local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class ReferralService {
    private readonly localStorage = inject(LOCALSTORAGE);

    private readonly REFERRAL_CODE = 'REFERRAL_CODE';

    getReferralCode(): string | null {
        return this.localStorage.getItem(this.REFERRAL_CODE);
    }

    storeReferralCode(code: string): void {
        this.localStorage.setItem(this.REFERRAL_CODE, code);
    }

    clearReferralCode(): void {
        this.localStorage.removeItem(this.REFERRAL_CODE);
    }
}
